import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LowBalanceNotificationsService {
  private apiUrl = '/api/users-low-balance';

  constructor(
    private http: HttpClient,
    public angularFireAuth: AngularFireAuth
  ) { }

  private getHeaders(idToken: string) {
    return new HttpHeaders({
      Authorization: idToken,
      'Content-Type': 'application/json'
    });
  }

  getPendingNotifications(cooldownDays: number = 7, limit: number = 100) {
    return this.angularFireAuth.idToken.pipe(
      mergeMap(idToken => {
        let params: string[] = [];
        if (cooldownDays !== null && cooldownDays !== undefined) {
          params.push(`cooldownDays=${cooldownDays}`);
        }
        if (limit) {
          params.push(`limit=${limit}`);
        }
        const queryString = params.length > 0 ? `?${params.join('&')}` : '';
        return this.http.get(
          `${this.apiUrl}/pending${queryString}`,
          { headers: this.getHeaders(idToken || '') }
        );
      })
    );
  }

  getReactedUsers(limit: number = 100) {
    return this.angularFireAuth.idToken.pipe(
      mergeMap(idToken => {
        return this.http.get(
          `${this.apiUrl}/reacted?limit=${limit}`,
          { headers: this.getHeaders(idToken || '') }
        );
      })
    );
  }

  sendNotifications(userIds: string[]) {
    return this.angularFireAuth.idToken.pipe(
      mergeMap(idToken => {
        return this.http.post(
          `${this.apiUrl}/send`,
          { userIds },
          { headers: this.getHeaders(idToken || '') }
        );
      })
    );
  }
}
